// @<COPYRIGHT>@
// ==================================================
// Copyright (c) 2020 Siemens
// Siemens Product Lifecycle Management Software Inc.
// All Rights Reserved.
// ==================================================
// @<COPYRIGHT>@

/**
 * @module js/swf3dWorkspaceInput
 */

import config from 'js/swf3dWorkspaceConfig';

/**
 * Method for get collab input data.
 *
 * @memberof js/swf3dWorkspaceInput
 * @function getCollabInputData
 * @example
 * swf3dWorkspaceInput.getCollabInputData();
 * @returns {object} - collab input data
 */
export function getCollabInputData() {
    return {
        urn: '',
        appInfo: config.appInfo,
        WSAuthorization: config.authorization,
        collabSpaceId: config.collabSpaceId,
        projectId: config.projectId,
        COLLAB: config.collabHost,
        DSS: config.dssHost
    };
}

/**
 * Method for get TC input data.
 *
 * @memberof js/swf3dWorkspaceInput
 * @function getTCInputData
 * @example
 * swf3dWorkspaceInput.getTCInputData();
 * @returns {object} - TC input data
 */
export function getTCInputData() {
    return {
        tenantId: config.get('tenantId')
    };
}

export default {
    getCollabInputData,
    getTCInputData
};
